<template>
    <v-layout row wrap>
        <v-flex xs12 pr-3 pl-3>
            <div>
            <v-text-field v-model="searchMerchants" label="Search merchants" append-icon="search" clearable clear-icon="mdi-close-circle-outline"></v-text-field>
            </div>
        </v-flex>
        <v-treeview v-model="tree" :items="channelsTree" :search="searchMerchants" activatable item-key="id" class="treeview" :active.sync="leaf" return-object>
        <template slot="prepend" slot-scope="{ item, open }">
            <v-icon v-if="item.children">
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
            </v-icon>
            <v-icon v-else>
                {{ 'mdi-record' }}
            </v-icon>
        </template>
        </v-treeview>
    </v-layout>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            tree: [],
            channelsTree: [],
            searchMerchants: null,
        }
    },
    computed: {
        leaf: {
            get() {
                return this.selected;
            },
            set(value) {
                if(value) {
                    this.$emit('leaf', value[0]);
                }    
            }
        }
    },
    props:{
        selected: Array
    },
    beforeMount() {
        this.getChannelsTree();
    },
    methods: {
        getChannelsTree() {
            axios({
            method: 'post',
            url: 'https://controlapi.totalprocessing.com/api/client-get-channels-2',
            data: { userId: localStorage.user_id },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                const keys = ["division", "merchant", "entity"];
                this.channelsTree = response.data
                    .reduce((r, o) => {
                        keys.reduce((t, k) => {
                            var temp = (t.children = t.children || []).find(p => p.id === o[k + 'Id']);
                            if (!temp) {
                                t.children.push(temp = { name: o[k + 'Name'], id: o[k + 'Id'] });
                            }
                            return temp;
                        }, r);
                        return r;
                    }, {})
                    .children;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
    }
}
</script>

<style>
    .v-treeview-node__label {
        margin-bottom: 0;
        text-align: left;
        font-size: 12px !important;
        cursor: pointer;
    }
    .theme--light.v-treeview .v-treeview-node--active {
        padding-right: 15px;
    }

    .v-treeview-node--active {
        background: none !important;
        color: #1976D2;
        font-weight: bold;
    }

    .v-treeview-node--active i {
        color: #1976D2 !important;
    }
 </style>
